module.exports = __webpack_public_path__ + "static/media/ciamaritima.a57edfee.png";